import { Body, VStack } from '@hover/blueprint';
import type { StackProps } from '@hover/blueprint';
import React from 'react';

interface BottomTextProps extends StackProps {
  primaryText?: string | null;
  secondaryText?: string | null;
}

const BottomText = ({
  primaryText,
  secondaryText,
  ...rest
}: BottomTextProps) => (
  <VStack alignItems="start" spacing="100" {...rest}>
    {primaryText && (
      <Body isSemiBold margin="0px">
        {primaryText}
      </Body>
    )}
    {secondaryText && (
      <Body color="neutral.500" margin="0px">
        {secondaryText}
      </Body>
    )}
  </VStack>
);

export { BottomText };
